export default class StockClotureJourPopupController {
	static $inject = ['$scope', '$stateParams', 'StocksCloturesService', 'notification', 'ModalService', '$uibModal', 'moment', '$translate'];

	constructor($scope, $stateParams, StocksCloturesService, notification, ModalService, $uibModal, moment, $translate) {
		this.$scope = $scope;
		this.$stateParams = $stateParams;
		this.StocksCloturesService = StocksCloturesService;
		this.notification = notification;
		this.ModalService = ModalService;
		this.$uibModal = $uibModal;
		this.moment = moment;
		this.$translate = $translate;
	}

	setWatchers() {
		var _this = this;
		this.$scope.$watch('$ctrl.date', function () {
			_this.verifieCloture();
		});
		this.$scope.$watch('$ctrl.siteSearch', function () {
			_this.verifieCloture();
		});
	}

	annuler() {
		this.modalInstance.close();
	}

	async appliquer() {
		if (this.checkDateValidation()) {
			const success = await this.modalToSave();
			if (success) {
				await this.getDerniereCloture();
			}
		} else {
			this.notification.error('STOCKS.DATE_CLOTURE_ERROR');
		}
	}

	async confirmer() {
		if (this.checkDateValidation()) {
			let success = await this.modalToSave();
			if (success) {
				this.annuler();
			}
		} else {
			this.notification.error('STOCKS.DATE_CLOTURE_ERROR');
		}
	}

	async $onInit() {
		this.isCloture = false;
		this.setWatchers();
		let siteInit = await this.StocksCloturesService.getRegroupementSites(null);
		if (siteInit.length == 1) {
			this.siteSearch = {
				id: siteInit[0].id,
				libelle: siteInit[0].libelle,
				code: siteInit[0].code
			};
		}
	}

	async getSites(valeur) {
		let sites = await this.StocksCloturesService.getRegroupementSites(valeur);
		return sites;
	}

	async verifieCloture() {
		if (this.date.indexOf('/') > -1) {
			this.isCloture = false;
			try {
				let siteId = this.siteSearch ? this.siteSearch.id : null;
				if (siteId && this.date) {
					this.isCloture = await this.StocksCloturesService.estCloture(siteId, this.date);
					if (this.isCloture) {
						this.derniereCloture = await this.StocksCloturesService.getClotureJour(siteId, this.date);
					} else this.getDerniereCloture();
				} else this.getDerniereCloture();
			} catch (ex) {
				this.notification.error(ex.data);
			}
		}
	}

	async modalToSave() {
		try {
			var modalToSaveReturn = false;
			var dateToCompare = this.moment(new Date()).format('DD/MM/YYYY');

			if (this.date == dateToCompare) {
				const modalInstance = this.ModalService.confirm({
					modalTitle: this.$translate.instant('STOCKS_CLOTURES.CLOTURE_JOURNALIERE.TITLE'),
					modalMsg: this.$translate.instant('STOCKS_CLOTURES.CLOTURE_JOURNALIERE.MESSAGE'),
					headerClass: 'modal-warning'
				});

				await modalInstance.result;
				modalToSaveReturn = await this.sauvegarder();
			} else {
				modalToSaveReturn = await this.sauvegarder();
			}
			return modalToSaveReturn;
		} catch (error) {
			console.log('🔥: StockClotureJourPopupController -> modalToSave -> error', error);
		}
	}

	async sauvegarder() {
		try {
			let siteId = this.siteSearch ? this.siteSearch.id : null;
			if (siteId && this.date) {
				await this.StocksCloturesService.getFormulesExpirees(siteId, this.date, true);
				//L'exécution peut être bloquée par la modale de 'getFormulesExpirees'
				this.startLoading();
				await this.StocksCloturesService.clotureJournaliere(siteId, this.date);
				this.notification.success('STOCKS_CLOTURES.CLOTURE_JOURNEE_EFFECTUEE');
				this.getDerniereCloture();
				return true;
			} else {
				this.notification.error('STOCKS_CLOTURES.CLOTURE_JOURNEE_PARAMETRE_MANQUANT');
			}
		} catch (ex) {
			this.notification.error(ex.data);
			return false;
		} finally {
			this.stopLoading();
		}
	}

	async getDerniereCloture() {
		if (!this.isCloture) {
			let siteId = this.siteSearch ? this.siteSearch.id : null;
			if (siteId) this.derniereCloture = await this.StocksCloturesService.getDerniereCloture(siteId);
			else this.derniereCloture = '';
		}
	}

	checkDateValidation() {
		var maDate = new Date();
		let newDate = this.moment(maDate, 'DD/MM/YYYY');

		let date = this.moment(this.date, 'DD/MM/YYYY');

		let resultat = true;
		if (date > newDate) resultat = false;

		return resultat;
	}

	async decloturer() {
		try {
			this.startLoading();
			let siteId = this.siteSearch ? this.siteSearch.id : null;
			if (siteId && this.date) {
				await this.StocksCloturesService.decloturer(siteId, this.date);
				this.verifieCloture();
				this.notification.success('STOCKS_CLOTURES.DECLOTURE_JOURNEE_EFFECTUEE');
				this.annuler();
			}
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
